import React from "react";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl, { useFormControl } from "@mui/material/FormControl";

export default function ErrorMsg({ message }) {
  return <FormHelperText className="error">{message}</FormHelperText>;
}
